<template>
	<div>
		<el-card class="table-card" shadow="always">
			<el-descriptions :column="1" border>
				<el-descriptions-item label="资产编号">{{ data.assetNo }}</el-descriptions-item>
				<el-descriptions-item label="资产名称">{{ data.assetName }}</el-descriptions-item>
				<el-descriptions-item label="所属项目">{{ data.communityName }}</el-descriptions-item>
			</el-descriptions>
			<div class="bts">
				<el-button type="primary" size="small" @click="showDetail">查看资产详情</el-button>
			</div>
		</el-card>
	</div>
</template>

<script>
	export default {
		name: 'AssetPlanAssetSelector',
		props: {
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {};
		},
		methods: {
			showDetail() {
				this.$router.push({
					path: '/pages/asset/assetLedger',
					query: {
						assetNo: this.data.assetNo,
					},
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	.table-card {
		margin-bottom: 15px;
		.bts {
			margin-top: 15px;
			display: flex;
			justify-content: center;
		}
	}
</style>
